export const professionalIsNew = (createdAt: string): boolean => {
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  return new Date(createdAt) > oneMonthAgo;
};
